/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Index/Template
 * @desc ExperimentWorkflow template index
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { ExperimentWorkflowActionCreateTemplate } from 'labstep-web/components/ExperimentWorkflow/Action/CreateTemplate';
import { ExperimentWorkflowListOrTable } from 'labstep-web/components/ExperimentWorkflow/ListOrTable';
import { ExperimentWorkflowTemplateEmptyState } from 'labstep-web/components/ExperimentWorkflowTemplate/EmptyState';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import { filtersTemplate } from 'labstep-web/screens/ExperimentWorkflow/Index/TableTimeline/constants';
import type React from 'react';
import { useMemo } from 'react';
import type { IExperimentWorkflowIndexTemplateProps } from './types';

export const ExperimentWorkflowIndexTemplate: React.FC<
  IExperimentWorkflowIndexTemplateProps
> = ({ group }) => {
  const params = useMemo(
    () => ({ group_id: group.id, is_template: true }),
    [group.id],
  );
  const noResultsMessage = useMemo(
    () => <ExperimentWorkflowTemplateEmptyState />,
    [],
  );
  const action = useMemo(
    () => <ExperimentWorkflowActionCreateTemplate />,
    [],
  );
  const searchBarProps = useMemo(
    () => ({ placeholder: 'Search templates...' }),
    [],
  );
  return (
    <EntitySearch
      params={params}
      noResultsMessage={noResultsMessage}
      filters={filtersTemplate}
      action={action}
      entityName={ExperimentWorkflow.entityName}
      bulkActions={[
        BulkAction.delete,
        BulkAction.transfer_ownership,
        BulkAction.share,
      ]}
      searchBarProps={searchBarProps}
    >
      {({ entities, ...rest }): React.ReactElement => (
        <ExperimentWorkflowListOrTable
          experimentWorkflows={entities}
          isTemplate
          {...rest}
        />
      )}
    </EntitySearch>
  );
};
